import { axios } from '@/utils/request'

const api = {
  course: '/course/course',
  search: '/course/course/search',
  section: '/course/course/section',
  allSection: '/course/course/section/all',
  lesson: '/course/course/lesson',
  category: '/course/category',
  categoryAll: '/course/category/all'
}

export default api

/**类型 */
export function getCategoryById(id) {
  return axios({
    url: `${api.category}/${id}`,
    method: 'get'
  })
}
export function getCategories() {
  return axios({
    url: api.categoryAll,
    method: 'get'
  })
}
export function addCategory(data) {
  return axios({
    url: api.category,
    method: 'post',
    data
  })
}
export function removeCategory(id) {
  return axios({
    url: `${api.category}/${id}`,
    method: 'delete'
  })
}
export function removeCategoryInBatch(params) {
  return axios({
    url: `${api.category}/inBatch`,
    method: 'delete',
    params
  })
}
export function updateCategory(id, data) {
  return axios({
    url: `${api.category}/${id}`,
    method: 'put',
    data
  })
}

/**课 */
export function getCourse(params) {
  return axios({
    url: api.course,
    method: 'get',
    params
  })
}

export function getCourseById(id) {
  return axios({
    url: `${api.course}/${id}`,
    method: 'get'
  })
}

export function searchCourse(params) {
  return axios({
    url: api.search,
    method: 'get',
    params
  })
}

export function addCourse(data) {
  return axios({
    url: api.course,
    method: 'post',
    data
  })
}

export function updateCourse(id, data) {
  return axios({
    url: `${api.course}/${id}`,
    method: 'put',
    data
  })
}

export function deleteCourse(params) {
  return axios({
    url: api.course,
    method: 'delete',
    params
  })
}

/**
 * 章
 */
export function getAllSection(params) {
  return axios({
    url: api.allSection,
    method: 'get',
    params
  })
}

export function getSectionById(id) {
  return axios({
    url: `${api.section}/${id}`,
    method: 'get'
  })
}

export function addSection(params, data) {
  return axios({
    url: api.section,
    method: 'post',
    params,
    data
  })
}

export function updateSection(id, data) {
  return axios({
    url: `${api.section}/${id}`,
    method: 'put',
    data
  })
}

export function removeSection(params) {
  return axios({
    url: api.section,
    method: 'delete',
    params
  })
}

/**
 * 节
 */
export function getLessonById(id) {
  return axios({
    url: `${api.lesson}/${id}`,
    method: 'get'
  })
}

export function addLesson(params, data) {
  return axios({
    url: api.lesson,
    method: 'post',
    params,
    data
  })
}

export function updateLesson(id, data) {
  return axios({
    url: `${api.lesson}/${id}`,
    method: 'put',
    data
  })
}

export function removeLesson(id) {
  return axios({
    url: `${api.lesson}/${id}`,
    method: 'delete'
  })
}
